import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ThanksPanel-wrapper" }
const _hoisted_2 = { class: "ThanksPanel-inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ThanksPanel-logo" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 190 66" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-logo" })
  ])
], -1)
const _hoisted_4 = { class: "ThanksPanel-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-active': _ctx.active, 'is-in': _ctx.isIn }, "ThanksPanel"]),
    style: _normalizeStyle({ height: _ctx.Viewport.windowHeight + 'px' }),
    "data-fixed": ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", {
            class: "ThanksPanel-title h1",
            innerHTML: _ctx.title
          }, null, 8, _hoisted_5),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.text), 1)
        ]),
        (_ctx.back)
          ? (_openBlock(), _createBlock(_component_ButtonHover, {
              key: 0,
              to: "/",
              class: "ThanksPanel-btn button button--brand"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('register-form.back-home')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 6))
}